<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="规格名称" prop="specName" >
        <a-input v-model="form.specName" placeholder="请输入规格名称" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSpec, addSpec, updateSpec,pageSpec } from '@/api/goods/spec'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      goodsList: [],
      // 表单参数
      form: {
        id: null,
        specName: null,
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        specName: [
          { required: true, message: '规格名称不能为空', trigger: 'blur' }
        ],
        goodsId: [
          { required: true, message: '商品ID不能为空', trigger: 'blur' }
        ]
      },
      specList:[],
    }
  },
  filters: {
  },
  created () {
    this.initGoods()
    
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    getList(){
    pageSpec(this.queryParam).then(response => {

        this.specList = response.data.records.map(item=>{
          return {specName:item.specName}
        })
     
  
      })
    },
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        specName: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.getList()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.getList()
      this.open = true
      this.formType = 2
      const id = row ? row.id : ids
      getSpec({"id":id}).then(response => {
        this.form = response.data

        this.formTitle = '修改'
      })
    },
    initGoods(){
      listGoodsInfo().then(res=>{
        this.goodsList = res.data
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      var isspecsTip = 0
        this.specList.forEach((it)=>{
          if(it.specName==this.form.specName){
          isspecsTip = 1
        
          }
      })
      if(isspecsTip == 1){
        this.$message.error('已存在同名规范，请勿重复添加')
      }
      else{
        this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSpec(this.form).then(res => {
              if(res.success){
                this.$message.success(
                  '修改成功',
                  3
                )
                this.open = false
                this.$emit('ok')
              }else{
                this.$message.error(
                  res.message,
                  3
                )
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSpec(this.form).then(res => {
              if(res.success){
                this.$message.success(
                  '新增成功',
                  3
                )
                this.open = false
                this.$emit('ok')
              }else{
                this.$message.error(
                  res.message,
                  3
                )
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
      }
    
    }
  }
}
</script>
